<template>
    <div class="configurator-preselector">
        <PreselectorStep class="preselector-step" name="make" title="Marke wählen" order="first" priority="Audi,BMW,VW,Mercedes Benz,Opel" />
        <PreselectorStep class="preselector-step" name="model" title="Modell wählen" order="second" />
        <PreselectorStep class="preselector-step" name="year" title="Erstzulassung ab" order="third" />
    </div>
</template>
<script>
import PreselectorStep from "./PreselectorStep";

export default {
    name: "Preselector",
    components: {
        PreselectorStep
    }
}
</script>
<style lang="scss" scoped>
    @import "~@/assets/vars";

    .configurator-preselector {
        @include breakpoint(frommediumlarge) {
            width:calc(75% - 2px);
            display: flex;
            justify-content: space-between;
        }
        .preselector-step {
            margin-bottom:16px;
            @include breakpoint(frommediumlarge) {
                width: 33%;
                margin-bottom:0;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/landing-components/Preselector.vue